import ArcaneFastApi from '@/services/arcane-fast-api';
import { registerFastApiClient } from '~/services/api/clients';

export default {
  install: (app) => {
    const {
      config: { globalProperties },
    } = app;
    const instance = new ArcaneFastApi(globalProperties);
    app.provide('arcaneFastApi', instance);
    registerFastApiClient(instance);
  },
};
